import React, { useEffect, useState } from 'react'
import { Col, Row, Collapse, Switch, Button, Tooltip } from 'antd'
import type {
    CorporateServicesView,
    ServiceStateInterface,
    ServiceCorporateTapss,
    ServiceCorporatepension,
    ServiceCorporatepaye,
    CompanyCTDetails,
} from '../../../../../../Types/Client/RegisteredClients/Corporate'
import { EditOutlined, EyeOutlined } from '@ant-design/icons'
import {
    GetPAYEService,
    GetPensionService,
    GetVATService,
    getClientCompanyDetails,
} from '../../../../../../Services/Corporate'
import { connect, useDispatch } from 'react-redux'
import Servicesless from '../../../../../../Layouts/Less/style.less'
import VATEdit, { vatdefaultdata } from './VATEdit'
import PensionEdit, { PensionData } from './PensionEdit'
import PAYEEdit, { PayeeDefaultData } from './PAYEEdit'
import VATForm from './VATForm'
import PensionForm from './PensionForm'
import PayeForm from './PayeForm'
import ActivePremission from '../../../../../../Utils/premissins'
import { PermissionType } from '../../../../../../Types/Enum/PermissionType'
import CTForm, { defaultCompanyDetails } from './CTForm'
import CtServiceViewPage from './CTServiceViewPage'
import { GetService } from '../../../../../../Services/SoleTrader'

const ServicesMain = (props: CorporateServicesView): React.ReactElement => {
    const { corporateTaps = [], corporateid } = props
    const { Panel } = Collapse
    const dispatch = useDispatch()
    const [PayeServiceData, setPayeServiceData] =
        useState<ServiceCorporatepaye>()
    const [VatServiceData, setVATServiceData] =
        useState<ServiceCorporateTapss>()
    const [PensionServiceData, setPensionServiceData] =
        useState<ServiceCorporatepension>()
    const [CTServiceData, setCTServiceData] = useState<CompanyCTDetails>()
    const [vateditData, setVatEditData] =
        useState<ServiceCorporateTapss>(vatdefaultdata)
    const [isVatEditMode, setIsVatEditMode] = useState(false)
    const [isPayeeEditMode, setIsPayeeEditMode] = useState(false)
    const [isPenitionEditMode, setIsPenisionEditMode] = useState(false)
    const [isCTEditMode, setIsCTEditMode] = useState(false)
    const [PenistioneditData, setPenitionEditData] =
        useState<ServiceCorporatepension>(PensionData)
    const [peyeeeditData, setpeyeeEditData] =
        useState<ServiceCorporatepaye>(PayeeDefaultData)
    const [CTeditData, setCTEditData] = useState<CompanyCTDetails>(
        defaultCompanyDetails
    )
    const VATServiceReferenceId = Array.isArray(corporateTaps)
        ? (corporateTaps.find((service) => service?.serviceName === 'VAT')
              ?.serviceReferenceId ?? 0)
        : 0

    useEffect(() => {
        if (VATServiceReferenceId > 0) {
            void GetVATService(dispatch, VATServiceReferenceId).then((data) => {
                if (data !== null) {
                    setVATServiceData(data?.data)
                }
            })
        }
    }, [VATServiceReferenceId, corporateid, corporateTaps])
    const CTService = Array.isArray(corporateTaps)
        ? corporateTaps.find((service) => service?.serviceName === 'CT')
        : undefined

    const CTServiceReferenceId = CTService?.serviceReferenceId ?? 0
    const CTserviceId = CTService?.serviceId ?? 0

    useEffect(() => {
        if (CTServiceReferenceId > 0) {
            void GetService(dispatch, CTserviceId, CTServiceReferenceId).then(
                (data) => {
                    if (data !== null) {
                        setCTServiceData(data)
                    }
                }
            )
        }
    }, [CTServiceReferenceId, corporateid, corporateTaps])

    const serviceReferenceId = Array.isArray(corporateTaps)
        ? (corporateTaps.find((service) => service?.serviceName === 'PAYE')
              ?.serviceReferenceId ?? 0)
        : 0
    useEffect(() => {
        if (serviceReferenceId > 0) {
            void GetPAYEService(dispatch, serviceReferenceId).then((data) => {
                if (data !== null) {
                    setPayeServiceData(data?.data)
                }
            })
        }
    }, [serviceReferenceId, corporateid, corporateTaps])

    const PensionServiceReferenceId = Array.isArray(corporateTaps)
        ? (corporateTaps.find((service) => service?.serviceName === 'Pension')
              ?.serviceReferenceId ?? 0)
        : 0

    useEffect(() => {
        if (PensionServiceReferenceId > 0) {
            void GetPensionService(dispatch, PensionServiceReferenceId).then(
                (data) => {
                    if (data !== null) {
                        setPensionServiceData(data?.data)
                    }
                }
            )
        }
    }, [PensionServiceReferenceId, corporateid, corporateTaps])

    const datareFetch = (): void => {
        void getClientCompanyDetails(dispatch, 1, corporateid, 4)
    }

    const vathandleEditClick = (): void => {
        setIsVatEditMode(!isVatEditMode)
        setVatEditData(VatServiceData ?? vatdefaultdata)
    }

    const CThandleEditClick = (): void => {
        setIsCTEditMode(!isCTEditMode)
        setCTEditData(CTServiceData ?? defaultCompanyDetails)
    }
    const CThandleChildFormSave = (): void => {
        setIsCTEditMode(false)
        datareFetch()
    }
    const vathandleChildFormSave = (): void => {
        setIsVatEditMode(false)
        datareFetch()
    }
    const PensionhandleEditClick = (): void => {
        setIsPenisionEditMode(!isPenitionEditMode)
        setPenitionEditData(PensionServiceData ?? PensionData)
    }

    const PensionhandleChildFormSave = (): void => {
        setIsPenisionEditMode(false)
        datareFetch()
    }
    const PayehandleEditClick = (): void => {
        setIsPayeeEditMode(!isPayeeEditMode)
        setpeyeeEditData(PayeServiceData ?? PayeeDefaultData)
    }

    const PayehandleChildFormSave = (): void => {
        setIsPayeeEditMode(false)
        datareFetch()
    }
    return (
        <>
            <Collapse
                expandIconPosition="end"
                onChange={() => {
                    setIsCTEditMode(false)
                }}
            >
                <Panel
                    header="CT"
                    key="1"
                    extra={
                        <Switch
                            checked={CTServiceData?.status === 'Active'}
                            onChange={() => {}}
                        />
                    }
                >
                    <Row gutter={16} justify="end">
                        <Col>
                            <Tooltip
                                title={`${isCTEditMode ? 'View Details' : 'Edit Details'}`}
                            >
                                <Button
                                    type="primary"
                                    onClick={CThandleEditClick}
                                >
                                    {isCTEditMode ? (
                                        <EyeOutlined />
                                    ) : ActivePremission(
                                          '3000',
                                          PermissionType.UPDATE
                                      ) ? (
                                        <EditOutlined />
                                    ) : (
                                        <></>
                                    )}
                                </Button>
                            </Tooltip>
                        </Col>
                    </Row>
                    {isCTEditMode ? (
                        <div>
                            <CTForm
                                ctServiceData={CTeditData}
                                isEditMode={isCTEditMode}
                                corporateId={corporateid}
                                onSave={CThandleChildFormSave}
                            />
                        </div>
                    ) : (
                        <CtServiceViewPage ctServiceData={CTServiceData} />
                    )}
                </Panel>
            </Collapse>
            <Collapse
                expandIconPosition="end"
                onChange={() => {
                    setIsVatEditMode(false)
                }}
            >
                <Panel
                    header="VAT"
                    key="2"
                    extra={
                        <Switch
                            checked={VatServiceData?.status === 'Active'}
                            onChange={() => {}}
                        />
                    }
                >
                    <Row gutter={16} justify="end">
                        <Col>
                            <Tooltip
                                title={`${isVatEditMode ? 'View Details' : 'Edit Details'}`}
                            >
                                <Button
                                    type="primary"
                                    onClick={vathandleEditClick}
                                >
                                    {isVatEditMode ? (
                                        <EyeOutlined />
                                    ) : ActivePremission(
                                          '3000',
                                          PermissionType.UPDATE
                                      ) ? (
                                        <EditOutlined />
                                    ) : (
                                        <></>
                                    )}
                                </Button>
                            </Tooltip>
                        </Col>
                    </Row>
                    {isVatEditMode ? (
                        <div>
                            <VATForm
                                vateditdata={vateditData}
                                corporateid={corporateid}
                                handleChildFormSave={vathandleChildFormSave}
                            />
                        </div>
                    ) : (
                        <VATEdit VATServiceData={VatServiceData} />
                    )}
                </Panel>
            </Collapse>
            <Collapse
                expandIconPosition="end"
                onChange={() => {
                    setIsPayeeEditMode(false)
                }}
            >
                <Panel
                    header="PAYE"
                    key="3"
                    extra={
                        <Switch
                            checked={PayeServiceData?.status === 'Active'}
                            onChange={() => {}}
                        />
                    }
                >
                    <Row gutter={16} justify="end">
                        <Col>
                            <Tooltip
                                title={`${isPayeeEditMode ? 'View Details' : 'Edit Details'}`}
                            >
                                <Button
                                    type="primary"
                                    onClick={PayehandleEditClick}
                                >
                                    {isPayeeEditMode ? (
                                        <EyeOutlined />
                                    ) : ActivePremission(
                                          '3000',
                                          PermissionType.UPDATE
                                      ) ? (
                                        <EditOutlined />
                                    ) : (
                                        <></>
                                    )}
                                </Button>
                            </Tooltip>
                        </Col>
                    </Row>
                    {isPayeeEditMode ? (
                        <div>
                            <PayeForm
                                PAYEServiceData={peyeeeditData}
                                onSave={PayehandleChildFormSave}
                                corporateId={corporateid}
                                isEditMode={isPayeeEditMode}
                            />
                        </div>
                    ) : (
                        <PAYEEdit PAYEServiceData={PayeServiceData} />
                    )}
                </Panel>
            </Collapse>
            <Collapse
                expandIconPosition="end"
                className={Servicesless.servicesform}
                onChange={() => {
                    setIsPenisionEditMode(false)
                }}
            >
                <Panel
                    header="Pension"
                    key="4"
                    extra={
                        <Switch
                            checked={PensionServiceData?.status === 'Active'}
                            onChange={() => {}}
                        />
                    }
                >
                    <Row gutter={16} justify="end">
                        <Col>
                            <Tooltip
                                title={`${isPenitionEditMode ? 'View Details' : 'Edit Details'}`}
                            >
                                <Button
                                    type="primary"
                                    onClick={PensionhandleEditClick}
                                >
                                    {isPenitionEditMode ? (
                                        <EyeOutlined />
                                    ) : ActivePremission(
                                          '3000',
                                          PermissionType.UPDATE
                                      ) ? (
                                        <EditOutlined />
                                    ) : (
                                        <></>
                                    )}
                                </Button>
                            </Tooltip>
                        </Col>
                    </Row>
                    {isPenitionEditMode ? (
                        <div>
                            <PensionForm
                                PensionServiceData={PenistioneditData}
                                isEditMode={isPenitionEditMode}
                                corporateId={corporateid}
                                onSave={PensionhandleChildFormSave}
                            />
                        </div>
                    ) : (
                        <PensionEdit PensionServiceData={PensionServiceData} />
                    )}
                </Panel>
            </Collapse>
        </>
    )
}
const mapStateToProps = (state: any): ServiceStateInterface => {
    return {
        corporateTaps: state.client.corporateTaps,
    }
}

export default connect(mapStateToProps)(ServicesMain)
